import React, { useState } from "react";
import { useLocation, useNavigate } from "react-router-dom";
import Header from "../../comps/Header";
import Footer from "../../comps/Footer";
import { user_profile_update } from "../../api/Auth";
import { toast } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import { ToastContainer } from "react-toastify";

const User_Profile_Edit = () => {
    const navigate = useNavigate();
    const location = useLocation();
    const get_profile = location?.state?.get_user_profile;
    const [showPassword, setShowPassword] = useState({
        current: false,
        new: false,
        confirm: false
    });


    // ✅ Define State Properly
    const [user, setUser] = useState({
        name: get_profile?.name || "",
        email: get_profile?.email || "",
        phone: get_profile?.phone || "",
        currentPassword: "",
        newPassword: "",
        confirmPassword: "",
    });

    // ✅ Handle Input Changes
    const handleChange = (e) => {
        const { name, value } = e.target;

        // Fields where spaces are not allowed
        const noSpaceFields = ["currentPassword", "newPassword", "confirmPassword"];
        const newValue = noSpaceFields.includes(name) ? value.replace(/\s/g, "") : value;

        setUser((prevUser) => ({
            ...prevUser,
            [name]: newValue,
        }));
    };

    const handleSubmit = async (e) => {
        e.preventDefault();
        if (!user?.name) {
            toast.error("Please fill the user name");
            return;
        }
        if (!user?.email) {
            toast.error("Please fill the user email");
            return;
        }
        if (user.newPassword) {
            if (user.newPassword.length < 8) {
                toast.error("The password must be at least 8 characters.");
                return;
            }
            if (user.newPassword !== user.confirmPassword) {
                toast.error("Passwords do not match!");
                return;
            }
        }

        try {
            const formData = new FormData();
            formData.append("name", user.name);
            formData.append("email", user.email);
            formData.append("phone", user.phone);
            formData.append("current_password", user.currentPassword);
            formData.append("new_password", user.newPassword);
            formData.append("password_confirmation", user.confirmPassword);

            // <---------- User Authentciation token's ------------>
            const token = localStorage.getItem("token");
            const headers = {
                "Authorization": `Bearer ${token}`
            };

            const response = await user_profile_update(headers, formData);
            if (response?.data?.status == "200") {
                toast.success(response?.data?.message)
                setTimeout(() => {
                    navigate("/my-account")
                }, 1500)
            }
            else if (response?.response?.data?.status == "400") {
                toast.error(response?.response?.data?.message)
            }
            else {
                toast.error(response?.data?.message)
            }
        } catch (error) {
            console.error("Error updating profile:", error);
            toast.error("Something went wrong. Please try again.");
        }
    };

    const togglePasswordVisibility = (field) => {
        setShowPassword((prev) => ({ ...prev, [field]: !prev[field] }));
    };

    return (
        <>
            <Header />
            {/* <-------- ToastContainer ------------> */}
            <ToastContainer style={{ marginTop: "120px" }} />
            <div className="max-w-2xl mx-auto mt-10 bg-white shadow-lg rounded-xl p-6 border border-gray-200 mb-10">
                <h2 className="text-2xl font-bold text-gray-800 text-center mb-4">
                    Edit Profile
                </h2>
                <form onSubmit={handleSubmit} className="space-y-4">
                    <div className="grid grid-cols-1 md:grid-cols-2 gap-4">
                        <div>
                            <label className="block text-gray-700 font-medium">Name</label>
                            <input type="text" name="name" value={user.name} onChange={handleChange} className="w-full px-4 py-2 mt-1 border rounded-lg focus:ring-2 focus:ring-blue-500 focus:outline-none" />
                        </div>
                        <div>
                            <label className="block text-gray-700 font-medium">Email</label>
                            <input type="email" name="email" value={user.email} onChange={handleChange} className="w-full px-4 py-2 mt-1 border rounded-lg focus:ring-2 focus:ring-blue-500 focus:outline-none" />
                        </div>
                    </div>

                    {/* Phone & Current Password */}
                    <div className="grid grid-cols-1 md:grid-cols-2 gap-4">
                        <div>
                            <label className="block text-gray-700 font-medium">Phone Number</label>
                            <input type="tel" name="phone" value={user.phone} onChange={handleChange} className="w-full px-4 py-2 mt-1 border rounded-lg focus:ring-2 focus:ring-blue-500 focus:outline-none" />
                        </div>
                        <div className="relative">
                            <label className="block text-gray-700 font-medium">Current Password</label>
                            <input
                                type={showPassword.current ? "text" : "password"}
                                name="currentPassword"
                                placeholder="leave blank to leave unchanged"
                                value={user.currentPassword}
                                onChange={handleChange}
                                className="w-full px-4 py-2 mt-1 border rounded-lg focus:ring-2 focus:ring-blue-500 focus:outline-none pr-10"
                            />
                            <span
                                onClick={() => togglePasswordVisibility("current")}
                                className="absolute right-3 top-9 text-gray-500 cursor-pointer"
                            >
                                {showPassword.current ? "🙈" : "👁️"}
                            </span>
                        </div>

                    </div>

                    {/*<--------- New Password & Confirm Password ----------> */}
                    <div className="grid grid-cols-1 md:grid-cols-2 gap-4">
                        {/* New Password */}
                        <div className="relative">
                            <label className="block text-gray-700 font-medium">New Password</label>
                            <input
                                type={showPassword.new ? "text" : "password"}
                                name="newPassword"
                                placeholder="leave blank to leave unchanged"
                                value={user.newPassword}
                                onChange={handleChange}
                                className="w-full px-4 py-2 mt-1 border rounded-lg focus:ring-2 focus:ring-blue-500 focus:outline-none pr-10"
                            />
                            <span
                                onClick={() => togglePasswordVisibility("new")}
                                className="absolute right-3 top-9 text-gray-500 cursor-pointer"
                            >
                                {showPassword.new ? "🙈" : "👁️"}
                            </span>
                        </div>

                        {/* Confirm Password */}
                        <div className="relative">
                            <label className="block text-gray-700 font-medium">Confirm Password</label>
                            <input
                                type={showPassword.confirm ? "text" : "password"}
                                name="confirmPassword"
                                placeholder="leave blank to leave unchanged"
                                value={user.confirmPassword}
                                onChange={handleChange}
                                className="w-full px-4 py-2 mt-1 border rounded-lg focus:ring-2 focus:ring-blue-500 focus:outline-none pr-10"
                            />
                            <span
                                onClick={() => togglePasswordVisibility("confirm")}
                                className="absolute right-3 top-9 text-gray-500 cursor-pointer"
                            >
                                {showPassword.confirm ? "🙈" : "👁️"}
                            </span>
                        </div>
                    </div>

                    <button type="submit" className="w-full bg-blue-600 text-white font-semibold py-2 rounded-lg hover:bg-blue-500 transition-all">Save Changes</button>
                </form>
            </div>
            <Footer />
        </>
    );
};

export default User_Profile_Edit;
